/** @jsxImportSource @emotion/react */
import type { ApiScanVideoSubmission } from '@kaiizen/kai-pro-api';

import { PlayGlyph } from '@/Client/Icons';

import { VideoListThumbnail } from '../../ScanVideoMedia';
import type { VideoToolboxClipReadStatus } from '../../VideoToolbox/videoToolboxClipReadStatusLib';
import type { FocusedMediaStripVideoEntry } from '../focusedMediaStripLib';
import type { FocusedStripStyles } from './focusedStripStyles';
import { getVideoChipLabel, getVideoTileLabel } from './focusedStripVideoTileLib';

export const FocusedStripVideoTile = ({
  video,
  submission,
  readStatus,
  showTaskChipLabels,
  styles,
  onClick,
}: {
  video: FocusedMediaStripVideoEntry;
  submission?: ApiScanVideoSubmission;
  readStatus: VideoToolboxClipReadStatus;
  showTaskChipLabels: boolean;
  styles: FocusedStripStyles;
  onClick: () => void;
}) => {
  const fileName = submission?.originalFileName;
  const thumbLabel = fileName ?? video.videoId;
  const chipLabel = getVideoChipLabel(video, showTaskChipLabels);

  return (
    <figure css={styles.figure}>
      <div css={styles.videoTile.stripTile} data-testid={'focused-media-video-tile'} data-video-id={video.videoId}>
        <button
          type={'button'}
          css={styles.videoTile.button}
          aria-label={getVideoTileLabel(video, fileName, readStatus)}
          onClick={onClick}
        >
          <VideoListThumbnail
            playbackUrl={submission?.playbackUrl}
            label={thumbLabel}
            styles={styles.videoTile.thumb}
          />
          <span css={styles.videoTile.playOverlay} aria-hidden={'true'}>
            <span css={styles.videoTile.playGlyphBox}>
              <PlayGlyph size={12} color={'currentColor'} />
            </span>
          </span>
          <span
            css={[
              styles.videoTile.readOverlay,
              readStatus === 'READ' ? styles.videoTile.readOverlayRead : styles.videoTile.readOverlayNotRead,
            ]}
            className={['pgd-vid-aud', readStatus === 'READ' ? 'is-ready' : 'is-todo'].join(' ')}
            data-testid={'focused-media-video-read-status'}
          >
            {readStatus}
          </span>
          {chipLabel ? <span css={styles.photoTile.chip}>{chipLabel}</span> : null}
        </button>
      </div>
      {video.dateLabel ? <span css={styles.caption}>{video.dateLabel}</span> : null}
    </figure>
  );
};
